
import dayjs from 'dayjs'
class TimeDesTools {
    static diffNow(targetMS: number) {
        // 获取当前时间
        const now = dayjs();

        // 目标时间，可以是任何过去的时间点
        const targetTime = dayjs(targetMS);
        // 计算时间差，单位为秒
        const secondPassed = now.diff(targetTime, "second");
        return secondPassed
    }

    static diffNowDes(targetMS: number, units: {
        second: string,
        minute: string,
        hour: string,
        day: string,
        format: string
    } = {
            second: 's',
            minute: 'm',
            hour: 'h',
            day: 'd',
            format: 'DD MMM YYYY',
        }) {
        const secondPassed = TimeDesTools.diffNow(targetMS)
        // XXX秒内
        if (secondPassed < 60) {
            return `${Math.max(secondPassed, 1)}${units.second}`
        }
        // XXX分钟内
        if (secondPassed < (60 * 60)) {
            return `${Math.floor(secondPassed / 60)}${units.minute}`
        }
        // XXX 小时内
        if (secondPassed < (60 * 60 * 24)) {
            return `${Math.floor(secondPassed / (60 * 60))}${units.hour}`
        }
        // XXX 天内 10为界限
        if (secondPassed < (10 * 24 * 60 * 60)) {
            return `${Math.floor(secondPassed / (24 * 60 * 60))}${units.day}`
        }
        return dayjs(targetMS).format(units.format)
    }
}

export { TimeDesTools }